import { useQuery, useQueryClient } from "@tanstack/react-query"
import {
  getAfterbanksSupportedBanks,
  getBankListFromAfterbanks,
} from "./Afterbanks.service"
import { GetAllSupportedBanksDtoProps } from "./DTOs/GetAllSupportedBanksDto"

export const useBankListFromAfterbanks = () => {
  const queryClient = useQueryClient()
  const {
    data: bankList,
    error: bankListError,
    isLoading: bankListIsLoading,
    refetch: bankListRefetch,
  } = useQuery({
    queryKey: ["bankList"],
    queryFn: getBankListFromAfterbanks,
    refetchOnWindowFocus: false,
    retry: false,
    retryOnMount: false,
    staleTime: 1000 * 60 * 60 * 8,
  })
  const bankListInvalidation = () =>
    queryClient.invalidateQueries({ queryKey: ["bankList"] })

  return {
    bankList,
    bankListError,
    bankListIsLoading,
    bankListRefetch,
    bankListInvalidation,
  }
}

export const useSupportedBanksFromAfterbanks = (queryParams: string) => {
  const queryClient = useQueryClient()
  const {
    data: supportedBanks,
    error: supportedBanksError,
    isLoading: supportedBanksIsLoading,
    refetch: supportedBanksRefetch,
  } = useQuery<GetAllSupportedBanksDtoProps[]>({
    queryKey: ["supportedBanks", queryParams],
    queryFn: async () => getAfterbanksSupportedBanks(queryParams),
    refetchOnWindowFocus: false,
    retry: false,
    retryOnMount: false,
    staleTime: 1000 * 60 * 60 * 8,
  })
  const supportedBanksInvalidation = () =>
    queryClient.invalidateQueries({ queryKey: ["supportedBanks"] })

  return {
    supportedBanks,
    supportedBanksError,
    supportedBanksIsLoading,
    supportedBanksRefetch,
    supportedBanksInvalidation,
  }
}
